export default __webpack_public_path__ + "static/media/ram.e23e904c.png";